<template>
  <svg
    :class="['vuesax-linear-brifecase-tick', className]"
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="path"
      d="M16 24.2666C18.9455 24.2666 21.3334 21.8788 21.3334 18.9333C21.3334 15.9878 18.9455 13.6 16 13.6C13.0545 13.6 10.6667 15.9878 10.6667 18.9333C10.6667 21.8788 13.0545 24.2666 16 24.2666Z"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      class="path"
      d="M13.92 19.0667L14.7867 19.9333C15.04 20.1867 15.4533 20.1867 15.7066 19.9467L18.08 17.76"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      class="path"
      d="M10.6666 29.3333H21.3333C26.6933 29.3333 27.6533 27.1867 27.9333 24.5733L28.9333 13.9067C29.2933 10.6533 28.36 8 22.6666 8H9.33331C3.63997 8 2.70664 10.6533 3.06664 13.9067L4.06664 24.5733C4.34664 27.1867 5.30664 29.3333 10.6666 29.3333Z"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      class="path"
      d="M10.6667 7.99996V6.93329C10.6667 4.57329 10.6667 2.66663 14.9334 2.66663H17.0667C21.3334 2.66663 21.3334 4.57329 21.3334 6.93329V7.99996"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      class="path"
      d="M28.8667 14.6666C26.56 16.3466 24 17.52 21.3467 18.1866"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      class="path"
      d="M3.49335 15.0266C5.72001 16.5466 8.14668 17.6266 10.6667 18.2399"
      stroke="#333333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: "VuesaxLinearBrifecaseTick",
  props: {
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>